import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PButton,
  PInlineNotification,
  PText,
} from '@porsche-design-system/components-react';

import { ActionGroup } from './ActionGroup';
import { Modal } from './Modal';
import { Spacer } from './Spacer';

const Content = styled('div', {
  base: {
    minWidth: '25rem',
  },
});

export const ConfirmationModal = ({
  open,
  onDismiss,
  onConfirm,
  heading,
  description,
  i18n,
  isLoading,
  error,
}: {
  open: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  heading: string;
  description: string;
  i18n: {
    cancel: string;
    confirm: string;
    error?: string;
  };
  isLoading?: boolean;
  error?: string;
}) => (
  <Modal
    open={open}
    onDismiss={() => {
      if (isLoading) return;
      onDismiss();
    }}
    size="initial"
  >
    <Modal.Header>{heading}</Modal.Header>

    {(error?.length ?? 0) > 0 ? (
      <>
        <PInlineNotification
          heading={i18n.error}
          description={error}
          state="error"
          dismissButton={false}
        />

        <Spacer mb="md" />
      </>
    ) : null}

    <Content>
      <PText>{description}</PText>
    </Content>

    <ActionGroup>
      <PButton
        type="button"
        variant="secondary"
        icon="close"
        disabled={isLoading}
        onClick={onDismiss}
      >
        {i18n.cancel}
      </PButton>
      <PButton
        type="button"
        variant="primary"
        loading={isLoading}
        onClick={onConfirm}
      >
        {i18n.confirm}
      </PButton>
    </ActionGroup>
  </Modal>
);
